import map from '@assets/map.svg';
import { QuestionInlineType } from '@data/types';
import classNames from 'classnames';
import React from 'react';
import { hash } from 'utilities/helper';

import Answer from './Answer';
import Prose from './Prose';
import QuestionText from './QuestionText';

interface Props extends QuestionInlineType {
  as?: keyof JSX.IntrinsicElements;
}

const QuestionDemographics: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent = '',
  question,
  answers,
  index = 0,
  selectedAnswers,
  setSelectedAnswers,
  id,
}) => {
  return (
    <Component className="w-full 2xl:mt-0" id={id}>
      <div className="relative flex flex-col">
        <Prose htmlContent={htmlContent} style="style-1" />
        <QuestionText text={question} />
        <div className="relative">
          <div className="overflow-hidden mb-12 md:mb-4">
            <div className="md:h-[450px] relative">
              <img
                src={map}
                alt="World Map"
                className="absolute inset-0 w-full h-full hidden md:block"
              />
              <ul className="flex flex-col gap-4 md:absolute md:inset-0">
                {answers.map((item, answerIndex) => (
                  <li
                    className={classNames('md:absolute', {
                      'md:top-[25%] md:left-[50%]': item.text === 'Europe',
                      'md:top-[55%] md:right-[10%]':
                        item.text === 'Asia / Asia-Pacific',
                      'md:top-[47.5%] md:left-[2.5%]':
                        item.text === 'North, Central and South America',
                      'md:top-[40%] md:left-[45%]':
                        item.text === 'Middle East & Africa',
                    })}
                    key={hash([item, answerIndex])}
                  >
                    <Answer
                      {...item}
                      questionIndex={index}
                      answerIndex={answerIndex}
                      questionText={question}
                      setSelectedAnswers={setSelectedAnswers}
                      selectedAnswers={selectedAnswers}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Component>
  );
};

export default QuestionDemographics;
